import React from "react";
import { Phone } from "lucide-react";
import { tarifs, site } from "../../mock";
import { SectionTitle } from "./Helpers";

export default function TarifsSection() {
  return (
    <section className="py-20 section-vignette">
      <div className="container-narrow">
        <SectionTitle
          over="Nos prestations"
          title="Un accompagnement sur mesure"
          sub="Chaque histoire est unique. Après un premier échange gratuit, Maître Diamma vous propose la formule la plus juste pour vous — sans surprise, ni engagement."
        />
        <div className="grid md:grid-cols-3 gap-6 mt-10">
          {tarifs.map((t, i) => <TarifCard key={t.titre} tarif={t} featured={i === 1} />)}
        </div>
        <p className="text-center text-xs text-gold-deep mt-6 max-w-xl mx-auto">
          La première prise de contact par téléphone ou WhatsApp reste toujours gratuite. Les honoraires sont annoncés clairement avant chaque intervention.
        </p>
      </div>
    </section>
  );
}

function TarifCard({ tarif, featured }) {
  return (
    <div className={`card-onyx rounded-xl p-8 text-center ${featured ? "gold-border-strong" : ""}`}>
      {featured && (
        <div className="inline-block text-[10px] uppercase tracking-[0.25em] text-black px-2 py-1 rounded-full mb-4" style={{background:"linear-gradient(180deg,#e6c25a,#b8892a)"}}>
          Le plus demandé
        </div>
      )}
      <h3 className="font-display text-xl text-gold mb-1">{tarif.titre}</h3>
      <p className="text-xs uppercase tracking-widest text-gold-deep mb-4">{tarif.duree}</p>
      <p className="text-sm text-gold-soft/95 mb-6 min-h-[48px]">{tarif.desc}</p>
      <a href={`tel:${site.phoneRaw}`} className="btn-gold inline-flex items-center gap-2 rounded-md px-5 py-2.5 text-sm">
        <Phone className="w-4 h-4" /> Demander un devis
      </a>
    </div>
  );
}
